export const getTransunionBlackBox = () => {
  if (window.transunion) {
    try {
      const { blackbox } = window.transunion.getBlackbox();

      return blackbox;
    } catch (e) {
      return undefined;
    }
  }

  return undefined;
};
